
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/riders-corner",
      function () {
        return require("private-next-pages/riders-corner/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/riders-corner"])
      });
    }
  